import axios from "axios";

import C from "../constants/constants";
import Http, { setupRefreshTokenInterceptor } from "../services/http.service";

/**
 * API methods for interacting with `/1/user/*` endpoint for authenticated users.
 */
const UserApi = {};

UserApi.update = async (userId, updateFields) =>
  (await Http.get().post(`${C.VITE_APP_EXPRESS_SERVER}/1/user/update/${userId}`, updateFields)).data;

UserApi.signOut = async () => (await Http.get().post(`${C.VITE_APP_EXPRESS_SERVER}/1/user/sign-out`)).data;

UserApi.refresh = async (authToken) => {
  const refreshInstance = axios.create({
    baseURL: C.VITE_APP_EXPRESS_SERVER,
    headers: {
      authorization: `Bearer ${authToken}`,
    },
    withCredentials: true,
  });

  setupRefreshTokenInterceptor(refreshInstance);

  return (await refreshInstance.post(`${C.VITE_APP_EXPRESS_SERVER}/1/user/refresh`)).data;
};

export default UserApi;
